import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { toast } from 'react-toastify';
import { deleteTask } from '../../../../../services/taskService';

const DeleteModal = ({ onDelete, deleteSelected, onClose }) => {
  const [isDeleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      if (deleteSelected) {
        setDeleting(true);
        const response = await deleteTask(deleteSelected?.id);
        toast.success(response?.data?.message);
        onDelete();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message ?? error.message);
    } finally {
      setDeleting(false);
    }
  };
  return (
    <Dialog open={deleteSelected} aria-labelledby="delete-dialog-title">
      <DialogTitle id="delete-dialog-title">Are you sure you want to delete "{deleteSelected?.taskName}"?</DialogTitle>
      <DialogActions>
        <Button disabled={isDeleting} onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton loading={isDeleting} onClick={handleDelete}>
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

DeleteModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  deleteSelected: PropTypes.object,
};

export default DeleteModal;
